import { useQuery, gql } from "@apollo/client";

const ACTIVE_STREAMS = gql`
  query {
    getUserById(userId: 1) {
      id
      email
    }
  }
`;

export const ProfilePage = () => {
  const { loading, error, data } = useQuery(ACTIVE_STREAMS);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error :(</p>;

  return (
    <>
      User Profile
      <br></br>
      {data.getUserById.email}
    </>
  );
};
